import _extends from 'babel-runtime/helpers/extends';

import CurveEditor from './curve-editor.vue';
import { EventBus, Event } from '@ps/utils/event-bus';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    CurveEditor: CurveEditor
  },

  data: function data() {
    return {
      initCurveValue: [[0, 0, 1, 1], [1, 1, 1, 1]]
    };
  },


  watch: {
    formValue: function formValue(data) {
      this.initCurveEdit(data);
    }
  },

  created: function created() {
    var _this = this;

    this.initCurveEdit(this.formValue);
    EventBus.$on(Event.ANIMATION_UPDATE, function () {
      _this.initCurveEdit(_this.formValue);
    });
  },


  props: {
    formValue: {
      type: Object
    }
  },
  computed: _extends({}, mapState({
    activeNode: function activeNode(state) {
      return state.workspace.game.activeNode;
    }
  })),

  methods: _extends({}, mapActions({
    setAnimation: 'workspace/game/setAnimation'
  }), {
    curveEdit: function curveEdit(_ref) {
      var keyframes = _ref.keyframes;

      var qc = this.$store.state.workspace.game.data;
      var curveArr = [];
      keyframes.forEach(function (item) {
        var kf = new qc.Keyframe(item[0], item[1], item[2], item[3]);
        curveArr.push(kf);
      });
      this.initCurveValue = keyframes;

      this.setAnimation({
        animations: {
          uuid: this.formValue.uuid,
          'curve': {
            keys: curveArr
          }
        },
        node: this.activeNode
      });
    },
    initCurveEdit: function initCurveEdit(data) {
      var curve = [];
      data._curve.keys.forEach(function (item) {
        var kf = [];
        kf.push(item.time);
        kf.push(item.value);
        kf.push(item.inTangent);
        kf.push(item.outTangent);
        curve.push(kf);
      });
      this.initCurveValue = curve;
    }
  })

};